import React, { useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { z } from "zod";
import { API_URL } from "../variables";

import "../styles/signinform.css";

const forgotPasswordSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }),
});

function ForgotPassword() {
  const [formData, setFormData] = useState({ email: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      forgotPasswordSchema.parse(formData);
      setIsSubmitting(true);
      const response = await axios.post(
        `${API_URL}/api/users/forgot-password`,
        formData
      );

      if (response.status === 200) {
        toast.success("Password reset instructions sent to your email!");
        setSubmitted(true);
      } else {
        toast.error(response.data.message || "Something went wrong.");
      }
    } catch (error) {
      if (error.name === "ZodError") {
        toast.error(error.errors[0].message);
      } else if (error.response) {
        toast.error(
          error.response.data.message || "An error occurred. Please try again."
        );
      } else {
        toast.error("An error occurred. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="sign-in-container">
      <ToastContainer />
      <div className="sign-in-form">
        <h1 className="sign-in-title">Forgot Password</h1>
        <p className="sign-in-subtitle">
          Recover your <span className="brand-name">K-Shop</span> account
        </p>

        {!submitted ? (
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email address..."
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                required
              />
            </div>

            <button
              type="submit"
              className="sign-in-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "Reset Password"}
            </button>

            <div className="additional-options">
              <p>
                Remember your password?{" "}
                <Link to="/signin" className="forgot-password">
                  Sign in
                </Link>
              </p>
              <p>
                Don't have an account?{" "}
                <Link to="/signup" className="forgot-password">
                  Sign up
                </Link>
              </p>
            </div>
          </form>
        ) : (
          <div className="success-message">
            <p>Check your email for instructions to reset your password.</p>
            <div className="additional-options">
              <p>
                <Link to="/signin" className="forgot-password">
                  Back to Sign in
                </Link>
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default ForgotPassword;
